import React, { useEffect, useState, Fragment } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { Card, Grid } from "@mui/material";

import utils from "../../../../utils";

import StyledCardDark from "../../shared/general/CardDark";

const rand40 = () => {
  return Math.floor(Math.random() * 40);
};

const StyledAvatar = styled(Avatar)({
  width: 40,
  height: 40,
});

const StyledWrapper = styled("div")({
  color: "#e6e5e8",
});

const StyledCellName = styled("div")({
  display: "flex",
  alignItems: "center",
  "& .MuiAvatar-root": {
    marginRight: 8,
  },
  "& .MuiTypography-h6": {
    lineHeight: 1,
  },
  "& .MuiTypography-body2": {
    color: "#999999",
    fontStyle: "oblique",
  },
});

const StyledCard = styled(Card)({
  borderRadius: 20,
  boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
  transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  backgroundColor: "#fff",
  color: "#007afe",
});

const StyledWrapEmployees = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "relative",
  "& .iconEmployee": {
    position: "absolute",
    right: 16,
    color: "#007afe",
    "& svg": {
      fontSize: 120,
    },
    "& i": {
      fontSize: 60,
    },
  },
});

export default function CardSummary(props) {
  const { value, top } = props;
  return (
    <StyledCard>
      <StyledWrapEmployees>
        <div
          style={{
            padding: 24,
            width: "80%",
            display: "flex",
            flexDirection: top ? "column" : "column-reverse",
          }}
        >
          <Typography color="text.secondary" variant="body1">
            {value.label}
          </Typography>
          {value.isPeople ? (
            <Typography variant="h3" align={top ? "center" : "left"}>
              {value.amount}
            </Typography>
          ) : (
            <Typography variant="h4" align={top ? "center" : "left"}>
              {utils.numberWithCommas(value.amount)}
            </Typography>
          )}
        </div>
        <div className={`iconEmployee`}>{value.icon}</div>
      </StyledWrapEmployees>
    </StyledCard>
  );
}
